import { loadConfiguratorOptions } from './optionActions';

const loadConfiguratorOptionsBySku = (selectedSku, onChoicesLoaded = null) => (dispatch, getState) => {
  const {
    products: { currentOmsId, currentSurfaceCodes },
  } = getState();
  if (currentOmsId && currentSurfaceCodes) {
    const { storeNumber } = getState().store;
    if (selectedSku) {
      return dispatch(loadConfiguratorOptions(storeNumber, selectedSku, onChoicesLoaded));
    }
  }
  return Promise.resolve();
};

export default loadConfiguratorOptionsBySku;
